
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/motor-insurance",
      function () {
        return require("private-next-pages/products/motor-insurance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/motor-insurance"])
      });
    }
  